import React, { useState, useEffect } from 'react';
import axios from "axios";

function ReviewSubmission() {

  const [submissions, setSubmissions] = useState([
    { submissionId: 29, tableName: 'players', idInserted: 2289, userId: 1, approved: 0 },
    { submissionId: 28, tableName: 'players', idInserted: 2288, userId: 1, approved: 0 },
    { submissionId: 27, tableName: 'players', idInserted: 2287, userId: 1, approved: 0 },
    { submissionId: 26, tableName: 'players', idInserted: 2286, userId: 1, approved: 0 },
    { submissionId: 25, tableName: 'players', idInserted: 2285, userId: 1, approved: 0 },
    { submissionId: 24, tableName: 'players', idInserted: 2284, userId: 1, approved: 0 },
    { submissionId: 23, tableName: 'players', idInserted: 2283, userId: 1, approved: 0 },
    { submissionId: 22, tableName: 'players', idInserted: 2282, userId: 1, approved: 0 },
    { submissionId: 21, tableName: 'players', idInserted: 2281, userId: 1, approved: 0 },
    { submissionId: 20, tableName: 'players', idInserted: 2280, userId: 1, approved: 0 },
    { submissionId: 19, tableName: 'players', idInserted: 2279, userId: 1, approved: 0 },
    { submissionId: 18, tableName: 'players', idInserted: 2278, userId: 1, approved: 0 },
    { submissionId: 17, tableName: 'variation', idInserted: 18, userId: 1, approved: 0 },
    { submissionId: 16, tableName: 'variation', idInserted: 17, userId: 1, approved: 0 },
    { submissionId: 15, tableName: 'cardvariation', idInserted: 9, userId: 1, approved: 0 },
    { submissionId: 14, tableName: 'variation', idInserted: 16, userId: 1, approved: 0 },
    { submissionId: 13, tableName: 'cardvariation', idInserted: 8, userId: 1, approved: 0 },
    { submissionId: 12, tableName: 'variation', idInserted: 15, userId: 1, approved: 0 },
    { submissionId: 11, tableName: 'variation', idInserted: 14, userId: 1, approved: 0 },
    { submissionId: 10, tableName: 'variation', idInserted: 13, userId: 1, approved: 0 },
    { submissionId: 9, tableName: 'players', idInserted: 2277, userId: 1, approved: 0 },
    { submissionId: 8, tableName: 'variation', idInserted: 12, userId: 1, approved: 0 },
    { submissionId: 7, tableName: 'players', idInserted: 2276, userId: 1, approved: 0 },
    { submissionId: 6, tableName: 'variation', idInserted: 11, userId: 1, approved: 0 },
    { submissionId: 5, tableName: 'players', idInserted: 2275, userId: 1, approved: 0 },]);
  const [selectedType, setSelectedType] = useState('');
  const [typeCounts, setTypeCounts] = useState({});

 
     // Function to count the different types
     const countTypes = (submissions) => {
      const counts = {};
  
      submissions.forEach((submission) => {
        const { tableName } = submission;
        counts[tableName] = (counts[tableName] || 0) + 1;
      });
  
      return counts;
    };

    // Update the type counts
     // Update the type counts
     useEffect(() => {
      setTypeCounts(countTypes(submissions));
    }, [submissions]);
 
/*
  useEffect(() => {
    // Fetch initial data when the component mounts

    fetchData();
   console.log('submission ',submissions)
  }, []);
*/
  const fetchData = async () => {
    try {
      // Make an initial request to get all submissions
      // Modify the endpoint based on your server API
      const response = await axios.get('/api/submissions');
      setSubmissions(response.data);
    } catch (error) {
      console.error('Error fetching submissions:', error);
    }
  };
  const handleApproval = (submissionId) => {
    // Simulated logic to update the approval status
    const updatedSubmissions = submissions.map(submission => {
      if (submission.submissionId === submissionId) {
        return { ...submission, approved: 1 }; // Assuming 1 represents approved
      }
      return submission;
    });

    setSubmissions(updatedSubmissions);
  };


  const handleTypeButtonClick = async (type) => {
    try {
      // Make a request to get submissions of the selected type
      // Modify the endpoint based on your server API
      
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/submissions?type=${type}`);
      setSubmissions(response.data);
      setSelectedType(type);
    } catch (error) {
      console.error(`Error fetching ${type} submissions:`, error);
    }
  };
  const TypePlayer = ({ submissionsFiltered }) => {
    // Check if the type is 'players'
    if (submissionsFiltered.length > 0 && selectedType === 'players') {
      // Render content for the 'players' type
      return (
        <div>
          <h2>Players Content</h2>
          {/* Add your specific rendering logic for the 'players' type */}
        </div>
      );
    }
  
    // Return null if the type is not 'players'
    return null;
  };
  const TypeVariation = ({ submissionsFiltered }) => {
    // Check if the type is 'players'
    if (submissionsFiltered.length > 0 && selectedType === 'variation') {
      // Render content for the 'players' type
      return (
        <div>
          <h2>Variation Content</h2>
          {/* Add your specific rendering logic for the 'players' type */}
        </div>
      );
    }
  
    // Return null if the type is not 'players'
    return null;
  };
  const TypeCardVariation = ({ submissionsFiltered }) => {
    // Check if the type is 'players'
    if (submissionsFiltered.length > 0 && selectedType === 'cardvariation') {
      // Render content for the 'players' type
      return (
        <div>
          <h2>cardvariation Content</h2>
          {/* Add your specific rendering logic for the 'players' type */}
        </div>
      );
    }
  
    // Return null if the type is not 'players'
    return null;
  };
  return (
    <div>
      {/* Buttons to select the type */}
      <button onClick={() => handleTypeButtonClick('players')}>Fetch Players {typeCounts["players"]}</button>
      <button onClick={() => handleTypeButtonClick('cardvariation')}>Fetch CardName {typeCounts["cardvariation"]}</button>
      <button onClick={() => handleTypeButtonClick('variation')}>Fetch Variations {typeCounts["variation"]}</button>

      {/* Render the submissions */}
      <ul>
      {submissions.map((submission, index) => (
  <li key={`${submission.submissionId}-${index}`}>
    Submission ID: {submission.submissionId}, Type: {submission.tableName}, Approved: {submission.approved}
    <button onClick={() => handleApproval(submission.submissionId)}>Approve</button>
      
  </li>
))}
      </ul>
      <TypePlayer submissionsFiltered={submissions} />
    </div>
  );
};

export default ReviewSubmission;
